export enum FundStatus {
  UNDER_APPROVAL = 'under_approval',
  APPROVED = 'approved',
  DRAFTED = 'drafted',
  UPCOMING = 'upcoming',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
}

export enum OfferingStatus {
  UNDER_APPROVAL = 'under_approval',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING_CLARIFICATION = 'pending_clarification',
  UPCOMING = 'upcoming',
  OPEN = 'open',
  COMPLETED = 'completed',
  CLOSED = 'closed',
}

export enum CapitalStatus {
  UNDER_APPROVAL = 'under_approval',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING_CLARIFICATION = 'pending_clarification',
}
